<template>
  <div class="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-600px w-100 p-10 auth-layout">
    <div class="d-flex flex-center flex-column flex-column-fluid px-lg-10">
      <form v-on:submit.prevent="login" class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework" novalidate="novalidate">
        <div class="text-center mb-11">
          <h1 class="text-dark fw-bolder mb-3">Авторизация</h1>
          <div class="text-gray-500 fw-semibold fs-6" v-if="!this.message">Введите логин и пароль</div>
          <div class="fw-bold fs-6 text-danger" v-else>{{ this.message }}</div>
        </div>
        <input-mask-field
            v-model="form.iin"
            id="form.iin"
            name="form.iin"
            :required="true"
            :mb="5"
            mask="############"
            placeholder="ИИН"
            type="text"
        />
        <input-field
            v-model="form.password"
            id="form.password"
            name="form_password"
            :required="true"
            :mb="5"
            placeholder="Пароль"
            type="password"
        />
        <input-field
            v-model="form.apc"
            id="form.apc"
            name="form.apc"
            :mb="5"
            placeholder="APC"
            type="text"
        />
        <div class="mt-3 mb-3 text-end">
          <router-link :to="{ name: 'ResetPassword' }" class="text-primary opacity-75">Забыли пароль?</router-link>
        </div>
        <div class="d-grid mb-10">
          <button class="btn btn-primary" :disabled="disabled || loading">
            <span class="indicator-label" v-if="!loading">Войти</span>
            <span class="indicator-progress d-block" v-else>Пожалуйста, подождите...
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import InputMaskField   from '@/components/Fields/InputMaskField';
import InputField       from '@/components/Fields/InputField';
import crypto           from '@/helpers/crypto'
import axios            from 'axios'

export default {
  name: 'AuthLogin',
  components: {InputMaskField, InputField},
  data() {
    return {
      form: {
        iin:      '',
        password: '',
        apc:      ''
      },
      message:  '',
      disabled: true,
      loading:  false
    }
  },
  mounted() {
    this.$store.dispatch("userRequest", null);
    localStorage.clear()
  },
  methods: {
    login() {
      this.loading = true
      axios.post('/api/login', this.form)
        .then(res => {
          if (res.data.access_token) {
            localStorage.setItem('user', crypto.encrypt(JSON.stringify(res.data.user)))
            localStorage.setItem('ttl', res.data.ttl)
            localStorage.setItem('ttlDate', res.data.ttlDate)
            localStorage.setItem('access', crypto.encrypt(res.data.access_token))
            this.$store.dispatch("userRequest", res.data.user);
            const ttlDate = new Date(res.data.ttlDate).getTime()
            this.$store.dispatch("tokenRequest", {
              ttl:res.data.ttl,
              date:ttlDate
            });
            window.location.href = '/'
          } else {
            if (Object.prototype.hasOwnProperty.call(res.data, 'result') && !res.data.result) {
              this.message = res.data.errors.join(', ')
              this.$notifyError(res.data)
              this.disabled = true
            }
          }
        })
        .catch(err => {
          if (Object.prototype.hasOwnProperty.call(err.response.data, 'result') && !err.response.data.result) {
            this.message = err.response.data.errors.join(', ')
            this.$notifyError(err.response.data)
          } else {
            this.message = err.message
          }
          this.disabled = true
        })
      .finally(() => {
        this.loading = false
      })
    }
  },
  watch:{
    form: {
      deep: true,
      handler: function(newValue) {
        if (newValue.apc) this.$nextTick(() => {this.form.apc = newValue.apc.replaceAll(/[^\p{L}\p{N}]/gu, '')});
        this.disabled = !(newValue.iin.length > 11 && newValue.password.length >= 8);
        this.message = ''
      },
    }
  }
}
</script>

<style></style>